import React from "react";
import ToursTableRow from "./ToursTableRow";

const ToursTable = ({ tours }) => {

  return (
    <table>
      <thead>
        <tr>
          <th className="left">Artist</th>
          <th className="left">Tour</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          tours.map(tour => <ToursTableRow tour={tour} key={tour._id} />)
        }
      </tbody>
    </table>
  )

};

export default ToursTable;